<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-app>
            <v-container fluid>

              <div class="d-flex justify-content-center flex-column align-items-center">
                <p>مدریت نوع های بیلبورد</p>
                <div class="d-inline-flex m-3 flex-column py-2 px-40" style="border: dashed 4px lightgray; border-radius: 20px">
                  <div v-for="(place , i) in places" :key="i" class="mt-8">

                    <component v-model="places[i]" text="name" :index="i"
                               @on-create-cancel="placeCreateCancel"
                               @create-submit="placeCreateSubmit"
                               @remove-submit="removePlace"
                               @update-submit="updatePlace"
                               label="نام مکان"
                               :hide-remove="hasChild(place.id)"
                               :wrong-name="getPlaceWrongName(i)"></component>
                    <div class="d-flex flex-column pt-2 px-3" style="position: relative; left:8rem; border-left: dashed 2px gray">

                      <component
                          v-for="(type, i) in types"
                          v-if="type.place_id == place.id"
                          v-model="types[i]" text="name" :index="i"
                          @on-create-cancel="typeCreateCancel"
                          @create-submit="typeCreateSubmit"
                         @remove-submit="removeType"
                         @update-submit="updateType"
                         label="نام نوع"
                         :hide-remove="false"
                         :wrong-name="getTypeWrongName(i , place.id)"></component>

                      <v-btn class="btn-add-with-text"  @click="addPlaceType(place.id)" v-if="place.id">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>

                    </div>
                  </div>

                  <v-btn class="btn-add-with-text mt-2" block @click="addPlace()">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>

                </div>
              </div>

            </v-container>


          </v-app>
          <!--                      <Wallet  :dialog="dialog" v-model="dialog" :wallet="userWallet" />-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import Component from "./Component"
import userManageButton from "@/view/pages/admin/users/userManageButton";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import actionButton from '@/view/content/button'

export default {
  components:{Component},
  data() {
    return {
      places : [],
      types : [],
    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }])
    this.fetchPlaces(this.url)

    window.Vue.$on('selectAllListCheckBox', (e) => {
      this.selectAll(e.checked);
    })


  },

  computed :{
    isValidInputInDialog(){
      return this.update.text.trim() && this.update.text.trim() !== this.update.currentText
    }
  },

  methods: {
    fetchPlaces(){
      this.requestApiGet('places', {withType:1})
          .then((res)=>{
            console.log(res.data.data);
            this.places = res.data.data;
            for(let item of this.places ?? []){
              console.log(item)
              this.types.push(...item.types);
            }
          });
    },


    placeCreateCancel(val, index){
        this.places.splice(index,1);
    },

    placeCreateSubmit(val, index, name){
      console.log(val , index , name)
      this.$modal.showLoading();
      this.requestApiPost('places' , {name:name})
          .then((res)=>{
            this.places.splice(index , 1 , res.data.data);
          }).catch((res)=>{
            this.$toast.error("خطا در ساخت مکان")
          }).finally(()=>{
            this.$modal.hideLoading();
          })
    },

    async removePlace(val, index){
      if (await this.$modal.yesNo('ایا از حذف مطمعین هستید؟')){
        this.$modal.showLoading();
        this.requestApiDelete('places/' + val.id)
            .then((res)=>{
              this.places.splice(index , 1);
            }).catch((res)=>{
          this.$toast.error("خطا در حذف مکان")
        }).finally(()=>{
          this.$modal.hideLoading();
        })
      }
    },

    updatePlace(val, index){
        this.$modal.showLoading();
        this.requestApiPut('places/' + val.id, {name: val.name})
            .then((res)=>{
              this.places.splice(index , 1, res.data.data);
            }).catch((res)=>{
          this.$toast.error("خطا در به روز رسانی مکان")
        }).finally(()=>{
          this.$modal.hideLoading();
        })
    },










    typeCreateCancel(val, index){
      this.types.splice(index,1);
    },

    typeCreateSubmit(val, index, name){
      console.log(val , index , name)
      this.$modal.showLoading();
      this.requestApiPost('billboardtype' , {name:name , place_id : val.place_id})
          .then((res)=>{
            this.types.splice(index , 1 , res.data.data);
          }).catch((res)=>{
        this.$toast.error("خطا در ساخت نوع")
      }).finally(()=>{
        this.$modal.hideLoading();
      })
    },

    async removeType(val, index){
      if (await this.$modal.yesNo('ایا از حذف مطمعین هستید؟')){
        this.$modal.showLoading();
        this.requestApiDelete('billboardtype/' + val.id)
            .then((res)=>{
              this.types.splice(index , 1);
            }).catch((res)=>{
          this.$toast.error("خطا در حذف نوع")
        }).finally(()=>{
          this.$modal.hideLoading();
        })
      }
    },

    updateType(val, index){
      this.$modal.showLoading();
      this.requestApiPut('billboardtype/' + val.id, {name: val.name, place_id : val.place_id})
          .then((res)=>{
            this.types.splice(index , 1, res.data.data);
          }).catch((res)=>{
        this.$toast.error("خطا در به روز رسانی نوع")
      }).finally(()=>{
        this.$modal.hideLoading();
      })
    },














    hasChild(place_id){
      for(let type of this.types){
        if (type.place_id === place_id){
          return true;
        }
      }
      return false;
    },









    getPlaceWrongName(index){
      let ret = []
      for (let item in this.places ?? []){
        if(item != index){
          ret.push(this.places[item].name);
        }
      }
      return ret;
    },




    getTypeWrongName(index, place_id){
      let ret = []
      for (let item in this.types ?? []){
        if(item != index && this.types[item].place_id == place_id ){
          ret.push(this.types[item].name);
        }
      }
      return ret;
    },



    addPlaceType(place_id){
        this.types.push({
          id : null,
          name : "",
          place_id : place_id
        })
    },


    addPlace(){
      this.places.push({
        id : null,
        name : "",
      })
    },




    addType() {
      this.clearCreatDialog();
      this.cuDialog = true;
      this.update.title = "اضافه کردن نوع";
      this.update.saveClick = this.submitCreateType;
    },

    submitCreateType(){
      this.$modal.showLoading();
      this.requestApiPost("billboardtype" , {
        name : this.update.text.trim()
      })
        .then((res)=>{
          this.$toast.success("با موفقیت ساخته شد");
          this.cuDialog = false;
          this.getTypes();
        }).catch((err)=>{
          this.$toast.error(err.response.data.message);
          this.update.errors = err.response.data.errors;
        }).finally((res)=>{
          this.$modal.hideLoading();
        })
    },


    submitUpdateType(){
      this.$modal.showLoading();

      this.requestApiPut("billboardtype/" + this.update.id , {
        name : this.update.text.trim()
      })
          .then((res)=>{
            this.$toast.success("با موفقیت ویرایش شد");
            this.cuDialog = false;
            this.getTypes();
          }).catch((err)=>{
          this.$toast.error(err.response.data.message);
          this.update.errors = err.response.data.errors;
      }).finally(()=>{
        this.$modal.hideLoading();
      })

    },

    clearCreatDialog(){
      this.update.currentText = ""
      this.update.text = "";
      this.update.id = -1;
    },

    async delType(id) {
      if (await this.$modal.yesNo(this.$t('CONFIRM.Delete'))) {
        this.$modal.showLoading();
        this.requestApiDelete('billboardtype/' + id)
            .then((a) => {
              this.$toast.success('با موفقیت حذف شد');
              this.getTypes();
            })
            .catch((e) => {
              if (e.response.status == 403){
                this.$toast.error(e.response.data.message);
              }else this.$toast.error('خطا در حذف اتفاق افتاده است (با پشتیبانی تماس بگیرید)');
            }).finally((e) => {
              this.$modal.hideLoading();
            })
      }
    },

    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id)
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length)
        ]

      }
      window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

    },

    filterOnlyCapsText(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
    },

    getTypes(url = this.url, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      }).finally(() => {
        this.$modal.hideLoading();
      })
    },

    reloadTable(params) {
      this.getBillBoards(this.url, params)
    },

    actions(data, type) {
      this[type](data)
    },
    edit(data) {
      this.$router.push({ name: 'admin.user.edit', params: { id: data.id } })
    },
    information(data) {
      this.$router.push({ name: 'admin.users.information', params: { id: data.id } })
    },
    // wallet(data) {
    //   this.$router.push({name: 'admin.users.walletEdit', params: {id: data.id}})
    //
    //   // if (data.wallets.length > 0) {
    //   //   this.dialog = true;
    //   //   return this.userWallet = data;
    //   // }
    //   // this.$toast.warning('کیف پول کاربر در حال حاضر وجود ندارد')
    //   // this.$router.push({name: 'admin.users.wallet', params: {id: data.id}})
    // },
  }
}

$('#select_all').click(function () {
  $('.checkBox').prop('checked', $(this).prop("checked"));
})
</script>
<style scoped>

.alert-warn {
  background-color: #CFD8DC;
}
.pending-status {
  background-color: rgb(224, 224, 94);
  padding: 0px 5px 0px 5px;
  font-weight: bold;
}
.accept-status {
  background-color: green;
  padding: 0px 5px 0px 5px;
  color: white;
  font-weight: bold;
}
.reject-status {
  background-color: red;
  padding: 0px 5px 0px 5px;
  color: white;
}
</style>
